import { Modules } from '../../../../dtos/Modules';

export interface ProgressModule {
    key: string;
    moduleId: Modules;
    abbrev: string;
    name: string;
    color: string;
}

export const MODULE_CATALOG: ProgressModule[] = [
    { key: 'pa', moduleId: Modules.PA, abbrev: 'PA', name: 'Pre-Award', color: '#5C6BC0' },
    { key: 'dc', moduleId: Modules.DC, abbrev: 'DC', name: 'Design & Construction', color: '#26A69A' },
    { key: 'ap', moduleId: Modules.AP, abbrev: 'AP', name: 'Prior Approval', color: '#AB47BC' },
    { key: 'co', moduleId: Modules.CO, abbrev: 'CO', name: 'Closeout', color: '#EF6C00' },
    { key: 'fo', moduleId: Modules.FO, abbrev: 'FO', name: 'Federal Oversight', color: '#5D4037' },
];
